import { useSyncExternalStore } from "react";

/** A tiny external store: a value, listeners, and a React hook. For app-wide state that isn't server data
 * (settings, the clock, the moment queue). Server data goes through TanStack Query instead. */
export function createStore<T>(initial: T) {
  let value = initial;
  const listeners = new Set<() => void>();
  return {
    get: () => value,
    set: (next: T | ((previous: T) => T)) => {
      value = typeof next === "function" ? (next as (previous: T) => T)(value) : next;
      listeners.forEach((listener) => {
        listener();
      });
    },
    subscribe: (listener: () => void) => {
      listeners.add(listener);
      return () => {
        listeners.delete(listener);
      };
    },
  };
}

export function useStore<T>(store: ReturnType<typeof createStore<T>>): T {
  return useSyncExternalStore(store.subscribe, store.get, store.get);
}
